import React from 'react';
import TitleText from '../../../../../Components/TitleText/TitleText';
import OnGoingProject from '../OnGoingProject/OnGoingProject';
import OwlCarousel from "react-owl-carousel";
const OnGoingProjects = (props) => {

    const options = {
        responsiveClass: true,
        dots: true,
        autoplayTimeout: 2000,
        autoplay: true,
        autoplayHoverPause: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            600: {
                items: 1,
            },
            700: {
                items: 2,
            },
            1000: {
                items: 2,

            }
        },
    };

    return (
        <div id='onGoingProjects' className='container '>
            <div className="row">
                <TitleText title1="ON GOING" title2="PROJECTS" position="center" />
            </div>
            {
                props.onGoingProjects.length && (
                    <OwlCarousel className="owl-theme" loop margin={40}{...options} >
                        {
                            props.onGoingProjects.map((projects) =>


                                < OnGoingProject key={projects.id} projects={projects} ></OnGoingProject>


                            )


                        }
                    </OwlCarousel>
                )
            }

        </div>
    );
};

export default OnGoingProjects;